import { Box, Typography } from '@mui/material'
import { Clock16Regular } from '@/components/Icon'
import SectionTabRow from './SectionTabRow'
import SearchRow from './SearchRow'
import ThreadListRow from './ThreadListRow'
import ThreadsSectionAllThreadsDialog from './ThreadsSectionAllThreadsDialog.jsx'
import ThreadsSectionViewAllButton from './ThreadsSectionViewAllButton.jsx'
import { useThreadsSectionFilter } from './useThreadsSectionFilter.js'
import { useThreadsSectionPreview } from './useThreadsSectionPreview.js'
import styles from './ThreadsSection.module.scss'

export default function ThreadsSection({
  threads = [],
  selectedThreadId,
  onSelectThread,
  onThreadMenuAction,
  onRenameThread,
  showSectionTabRow = true,
}) {
  const { searchValue, setSearchValue, filteredThreads } = useThreadsSectionFilter(threads)
  const { visibleThreads, viewAllOpen, hasMoreThanPreview, openViewAll, closeViewAll } =
    useThreadsSectionPreview(filteredThreads)

  return (
    <Box className={styles.wrap}>
      <SearchRow
        value={searchValue}
        onChange={setSearchValue}
        placeholder="Search threads"
      />
      {showSectionTabRow ? <SectionTabRow label="Threads" Icon={Clock16Regular} /> : null}
      {threads.length === 0 ? (
        <Box className={styles.emptyOuter}>
          <Box className={styles.emptyInner}>
            <Typography component="p" className={styles.emptyText}>
              Start conversation to see your History here
            </Typography>
          </Box>
        </Box>
      ) : filteredThreads.length === 0 ? (
        <Typography sx={{ px: 1.25, py: 1, fontSize: 13, lineHeight: 1.4, color: 'text.secondary' }}>
          No matching threads.
        </Typography>
      ) : (
        <>
          <Box component="ul" className={styles.list} aria-label="Threads">
            {visibleThreads.map((thread) => (
              <Box component="li" key={thread.id} className={styles.listItem}>
                <ThreadListRow
                  title={thread.title}
                  thread={thread}
                  menuSurface="threads"
                  active={thread.id === selectedThreadId}
                  onClick={() => onSelectThread?.(thread)}
                  onThreadMenuAction={onThreadMenuAction}
                  onRenameThread={onRenameThread}
                />
              </Box>
            ))}
          </Box>
          {hasMoreThanPreview ? <ThreadsSectionViewAllButton onClick={openViewAll} /> : null}
        </>
      )}
      <ThreadsSectionAllThreadsDialog
        open={viewAllOpen}
        onClose={closeViewAll}
        threads={threads}
        selectedThreadId={selectedThreadId}
        onSelectThread={onSelectThread}
        onThreadMenuAction={onThreadMenuAction}
        onRenameThread={onRenameThread}
      />
    </Box>
  )
}
